import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import style from './style.m.less'

interface IButtonsBlock {
    confirmAction?: () => void
    cancelAction?: () => void
    confirmTitle?: string
    margin?: boolean
    isDelete?: boolean
}

const ButtonsBlock: FC<IButtonsBlock> = ({ confirmAction, cancelAction, margin }) => {
    const { t } = useTranslation()

    return (
        <div className={margin ? style.buttonsBlockMargin : style.buttonsBlock}>
            <button type="button" className={style.primaryButtonCancel} onClick={cancelAction}>
                {t('calculator.buttons.reset')}
            </button>
            <button
                type="submit"
                onClick={confirmAction}
                className={style.primaryButton}
                style={{ marginLeft: '16px', padding: '8px 16px' }}
            >
                {t('calculator.buttons.calculate')}
            </button>
        </div>
    )
}

export default ButtonsBlock
